import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { CampanhaSearch } from '../../campanha-search';

@Injectable({
    providedIn: 'root'
})
export class CampanhaEncerramentoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/campanha`;
    }


    /** Encerra a campanha */
    encerrar(idCampanha: number): Observable<CampanhaSearch> {
        return this.customHttp.put<CampanhaSearch>(`${this.pathApi}/${idCampanha}/encerramento/encerrar`, null);
    }
}
